import React from 'react';
import { ShieldCheck, Smartphone, CreditCard, Ban } from 'lucide-react';
export function GuaranteeBar() {
  const items = [{
    icon: ShieldCheck,
    text: 'Garantía de 30 Días'
  }, {
    icon: Smartphone,
    text: 'Acceso Inmediato'
  }, {
    icon: CreditCard,
    text: 'Un Solo Pago'
  }, {
    icon: Ban,
    text: 'Sin Suscripciones'
  }];
  return <div className="w-full bg-[#050505] border-y border-white/5 py-8 px-4" data-id="element-37">
      <div className="max-w-5xl mx-auto flex flex-wrap justify-center gap-6 md:gap-12" data-id="element-38">
        {items.map((item, index) => <div key={index} className="flex items-center text-zenith-muted" data-id="element-39">
            <item.icon className="w-5 h-5 text-zenith-red mr-2" data-id="element-40" />
            <span className="text-sm md:text-base font-medium" data-id="element-41">
              {item.text}
            </span>
          </div>)}
      </div>
    </div>;
}